'use client'

import { type PropsWithChildren } from 'react'

import { PORTAL_TUTORIAL_TARGETS, type PortalTutorialTargetId } from '../../const/portal-tutorial-targets.const'

type PortalTutorialTargetProps = PropsWithChildren<{
  id: PortalTutorialTargetId
  className?: string
}>

export function PortalTutorialTarget({ id, className, children }: PortalTutorialTargetProps) {
  return (
    <div className={className} data-portal-tutorial={id} style={{ display: 'contents' }}>
      {children}
    </div>
  )
}

export { PORTAL_TUTORIAL_TARGETS }
